export default {"src":"/_next/static/media/Heart Failure.19f12f8e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};